import { LifeTransactionType } from '../enums';

export const LifeConstants = {
  // Life Transaction Amounts
  rescueShiftHealAmount: 1,
  unexcusedAbsencePenaltyAmount: -2,
  attendanceStreakAmount: 1,
  canceledLateShiftAmount: -1,
  approvedExcuseAmount: 1,

  // Other
  attendancesNeededForStreak: 20,
  banThreshold: -3,
  maxLives: 3,
  onlyRescueShiftThreshold: 0,
};

export const LifeTransactionAmounts: Record<LifeTransactionType, number> = {
  [LifeTransactionType.INITIAL]: LifeConstants.maxLives,
  [LifeTransactionType.UNEXCUSED_ABSENCE]:
    LifeConstants.unexcusedAbsencePenaltyAmount,
  [LifeTransactionType.MANUAL]: 0,
  [LifeTransactionType.RESCUE_SHIFT]: LifeConstants.rescueShiftHealAmount,
  [LifeTransactionType.ATTENDANCE_STREAK]: LifeConstants.attendanceStreakAmount,
  [LifeTransactionType.CANCELED_LATE_SHIFT]:
    LifeConstants.canceledLateShiftAmount,
  [LifeTransactionType.APPROVED_EXCUSE]: LifeConstants.approvedExcuseAmount,
};
